import styled from 'styled-components';
import { StyledBaseWrapper } from '../styles';

export const StyledGenericWrapper = styled(StyledBaseWrapper)`
  // Generic-specific styles
`;
